import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import { useRequirementDefaultActions } from "../../../../hooks/useRequirementDefaultActions";
import {
  CellsConfig,
  ContextItem,
  RequirementContextType,
  RequirementTableCallback
} from "../../../../types";
import { getRegistrationRequirementName } from "../helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayerStatusCell } from "../helpers/getRegistrationRequirementPayerStatusCell";

export const usePayeeRegistrationConfig = (
  callback: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  InsuranceCoverageMonitor | undefined
> => {
  const defaultRequirementActions = useRequirementDefaultActions(
    RequirementContextType.Payee,
    callback
  );

  return {
    isActionRequired: () => false,

    requirementName: getRegistrationRequirementName,

    toolbarActions: (requirement, context, additionalData) => {
      return [];
    },

    nameCell: requirement => ({
      text: getRegistrationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getRegistrationRequirementPayerStatusCell
  };
};
